import TableIcon from '@assets/icons/table.svg?react';
import { ComponentProps, FC } from 'react';
import { BaseModal } from '../BaseModal';
import { ModalPattern } from '../common';
import { ConfirmationModalFooter } from './ConfirmationModalFooter';

type ConfirmationModalProps = ComponentProps<typeof BaseModal> & Omit<ComponentProps<typeof ConfirmationModalFooter>, 'onCancel'>;

export const ConfirmationModal: FC<ConfirmationModalProps> = ({ children, onClose, classNames, isDismissable, ...footerProps }) => {
  return (
    <BaseModal onClose={onClose} classNames={classNames} isDismissable={isDismissable}>
      <ModalPattern />
      <div className='flex flex-col gap-4'>
        <TableIcon className='size-12 text-brand-600' />
        {children}
      </div>
      <div className='flex flex-col gap-4'>
        <ConfirmationModalFooter onCancel={onClose} {...footerProps} />
      </div>
    </BaseModal>
  );
};
